import * as Sentry from '@sentry/react';
import Fallback from './Fallback';

type Props = {
  children?: JSX.Element[];
};

const ErrorBoundary = (props: Props) => {
  return (
    <Sentry.ErrorBoundary fallback={<Fallback />}>
      {props.children}
    </Sentry.ErrorBoundary>
  );
};

export default ErrorBoundary;
